<template>
    <div v-if="totalPages > 1">
        <ul class="pagination">
            <li class="pagination-item">
                <input type="button" @click="onClickFirstPage " :disabled="isInFirstPage" aria-label="Go to first page " value="<<">
            </li>
            <li class="pagination-item">
                <input type="button" @click="onClickPreviousPage " :disabled="isInFirstPage" aria-label="Go to previous page " value="<">
            </li>
            <li v-for="page in pages" class="pagination-item">
                <input type="button" @click="onClickPage(page.name) " :disabled="page.isDisabled" :class="{ active: isPageActive(page.name) }" :value=" page.name" />
            </li>
            <li class="pagination-item">
                <input type="button" @click="onClickNextPage " :disabled="isInLastPage" aria-label="Go to next page " value=">" />
            </li>
            <li class="pagination-item">
                <input type="button" @click="onClickLastPage " :disabled="isInLastPage" aria-label="Go to last page " value=">>" />
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        props: {
            maxVisibleButtons: {
                type: Number,
                required: false,
                default: 5
            },
            totalPages: {
                type: Number,
                required: true
            },
            total: {
                type: Number,
                required: true
            },
            perPage: {
                type: Number,
                required: true
            },
            currentPage: {
                type: Number,
                required: true
            },
        },
        computed: {
            startPage: function () {
                if (this.currentPage === 1) {
                    return 1;
                }

                if (this.currentPage === this.totalPages) {
                    return this.totalPages - this.maxVisibleButtons + 1;
                }

                return this.currentPage - 1;

            },
            endPage: function () {

                return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);

            },
            pages: function () {
                const range = [];

                for (let i = this.startPage; i <= this.endPage; i += 1) {
                    if (i > 0) {

                        range.push({
                            name: i,
                            isDisabled: i === this.currentPage
                        });
                    }
                }
                return range;
            },
            isInFirstPage: function () {
                return this.currentPage === 1;
            },
            isInLastPage: function () {
                return this.currentPage === this.totalPages;
            },
        },
        methods: {
            onClickFirstPage: function () {
                this.$emit('pagechanged', 1);
            },
            onClickPreviousPage: function () {
                this.$emit('pagechanged', this.currentPage - 1);
            },
            onClickPage: function (page) {
                this.$emit('pagechanged', page);
            },
            onClickNextPage: function () {
                this.$emit('pagechanged', this.currentPage + 1);
            },
            onClickLastPage: function () {
                this.$emit('pagechanged', this.totalPages);
            },
            isPageActive: function (page) {
                return this.currentPage === page;
            },
        }
    };
</script>